import React, { useState, useEffect } from "react";
import axios from "axios";
import { WEBSERVICE } from "../../CoreDataService";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Modal,
  Button,
  CircularProgress,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Box,
  Grid,
} from "@mui/material";
import { useSelector } from "react-redux";
import DataTable from "../../Common/DataTable";
import { ContainedButton } from "../../Common/Buttons";

const FeeModalFutureOption = ({ open, onClose, flag }) => {
  const [loading, setLoading] = useState(false);
  const [userExchangeFee, setUserExchangeFee] = useState({
    totalVolume: 0,
    totalFees: 0,
    totalIntAccrued: 0,
    totalIntEarned: 0,
  });
  const [exchangeFees, setExchangeFees] = useState([]);
  const [error, setError] = useState(null);
  const { brokerBasicInfo, brokerDetailedInfo } = useSelector((state) => state);

  useEffect(() => {
    if (open) {
      fetchFees();
    }
  }, [open]);

  const fetchFees = async () => {
    setLoading(true);
    setError(null);

    const url = flag
      ? "/fMargin/fundingHomeView"
      : "/optionsMargin/fundingHomeView";
    const secondUrl = flag
      ? "/fTrade/userWiseTradingFees?uuid="
      : "/optionsTrade/userWiseTradingFees?uuid=";

    try {
      // Fetch volume-wise trading fees
      const response = await axios.get(WEBSERVICE + url, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      });
      const tradingFees = response?.data;
      setExchangeFees(tradingFees.P_FUNDING_CURRENCY);

      // Fetch user-specific trading fees
      const { data: userFees } = await axios.get(
        WEBSERVICE + `${secondUrl}${localStorage.getItem("uuid")}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      setUserExchangeFee({
        totalVolume: parseFloat(
          userFees.userTradingFees[0].totalVolume
        ).toFixed(2),
        totalFees: parseFloat(userFees.userTradingFees[0].totalFees).toFixed(2),
        totalIntAccrued: userFees.userTradingFees[0].totalIntAccrued,
        totalIntEarned: userFees.userTradingFees[0].totalIntEarned,
      });
    } catch (error) {
      //   setError("Could not fetch the data.");
    } finally {
      setLoading(false);
    }
  };
  console.log("exchangefreeee", exchangeFees);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ textAlign: "center" }}>
        Fees
        <Button onClick={onClose} style={{ float: "right" }} variant="text">
          &times;
        </Button>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="h6" gutterBottom>
          Summary - 30 Days
        </Typography>

        {loading ? (
          <CircularProgress />
        ) : (
          <>
            <DataTable
              columns={[
                "Total Volume",
                "Total Fees Accrued",
                "Total Interest Accrued",
                "Total Interest Earned",
              ]}
            >
              <TableRow>
                <TableCell>${userExchangeFee.totalVolume}</TableCell>
                <TableCell>${userExchangeFee.totalFees}</TableCell>
                <TableCell>${userExchangeFee.totalIntAccrued}</TableCell>
                <TableCell>${userExchangeFee.totalIntEarned}</TableCell>
              </TableRow>
            </DataTable>

            <Typography variant="h6" gutterBottom>
              Exchange Fees
            </Typography>

            <DataTable
              columns={[
                "Currency",
                "Transaction Charge",
                "Total Daily Interest Paid by Borrower (%)",
                "Interest Earned by Lender of Total (%)",
                "Interest Earned by Exchange of Total (%)",
              ]}
            >
              {exchangeFees.length !== 0 ? (
                exchangeFees.map((fee, index) => (
                  <TableRow key={index}>
                    <TableCell>{fee.CURRENCY_NAME}</TableCell>
                    <TableCell>{fee.TXN_CHARGE}</TableCell>
                    <TableCell>{fee.INTEREST}</TableCell>
                    <TableCell>{fee.LENDER_EARNED_INTEREST}</TableCell>
                    <TableCell>{fee.EXCHANGE_EARNED_INTEREST}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No exchange fees data available.
                  </TableCell>
                </TableRow>
              )}
            </DataTable>

            {/* <Typography variant="body2" color="textSecondary">
              {brokerBasicInfo?.exchange} uses a maker-taker fee model for
              determining its trading fees. Orders that provide liquidity (maker
              orders) are charged different fees than orders that take liquidity
              (taker orders).
              <b>
                Fees are calculated based on the current pricing tier you are in
                when the order is placed, and not on the tier you would be in
                after a trade is completed.
              </b>{" "}
              When you place an order at the market price that gets filled
              immediately, you are considered a taker. When you place an order
              which is not immediately matched by an existing order, that order
              is placed on the order book. If another customer places an order
              that matches yours, you are considered the maker. When you place
              an order that gets partially matched immediately, you pay a taker
              fee for that portion. The remainder of the order is placed on the
              order book and, when matched, is considered a maker order.
            </Typography> */}
          </>
        )}

        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center" }}>
        <ContainedButton onClick={onClose} variant="contained" size="small">
          Close
        </ContainedButton>
      </DialogActions>
    </Dialog>
  );
};

export default FeeModalFutureOption;
